import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { FeatureKey } from 'src/app/_models';
import { FeaturesBaseServices } from './../../features/services/features-base.services';
import { Rights } from './../../../_models/feature';
import { BaseServices } from './../../kuba.services';
import { EmployeeServices } from './../services/employee.services';
import { HelperService } from '../../../_services/helper.service';
import {
  EmployeeTabRights,
  employeeListTabs,
  employeeTabLinkText,
  employeeTabRights
} from '../employee-tabs.rules';
import { BusinessPortalService } from 'src/app/kuba/portals/services/business-portal.services';
import { Subscription } from 'rxjs';
import { canUseWorkEnvironmentSurvey } from '../work-environment-survey/work-environment-survey-access';

@Component({
  selector: 'employee-tabs',
  templateUrl: 'employee-tabs.component.html',
  standalone: false
})
export class EmployeeTabComponent implements OnInit {
  //#region variables
  employeeView = true;
  name = '';
  employeeId: number;
  enableLinks = false;
  title: string;
  newEmpoyee: boolean;
  rightsData: EmployeeTabRights | undefined;
  enabledAdditionalFeatures: any;
  @Input() parentRoute: string;
  employeeDepartmentId: number;
  loginEmployeeDepartmentId: number;
  IsCommonPortalCourseNames = true;
  eId: any;
  employeeTitle: string = 'EMPLOYEES';
  employeeName: string = '';
  private subscriptions: Subscription[] = [];
  //#endregion

  //#region constructor
  /**
   * constructor
   * @param router {Router}
   * @param route {ActivatedRoute}
   * @param employeeServices {EmployeeServices}
   */
  constructor(
    private route: ActivatedRoute,
    private employeeServices: EmployeeServices,
    private featuresBaseServices: FeaturesBaseServices,
    private businessPortalService: BusinessPortalService
  ) {
    this.employeeId = this.route.snapshot.params['id'];
    this.subscriptions.push(
      this.featuresBaseServices.getEmployeeNavigationAccess$.subscribe(
        isEditMode => {
          if (!isEditMode) {
            this.enabledAdditionalFeatures = employeeListTabs(
              JSON.parse(sessionStorage.getItem('workingModule')!).children,
              BaseServices.roleId
            );
            this.appendWorkEnvironmentSurveyTab();
            this.employeeView = false;
            this.enableLinks = false;
            this.employeeId = 0;
          } else {
            if (route.snapshot.parent!.data['parent'] === 'MYPAGE') {
              this.employeeId = +BaseServices.FeatureKey;
            } else {
              this.subscriptions.push(
                this.route.firstChild.params.subscribe((params: Params) => {
                  this.employeeId = +params['eid'];
                })
              );
            }
            this.employeeView = true;
          }
          if (this.employeeId > 0) {
            this.enableLinks = true;
            let leftNav = JSON.parse(sessionStorage.getItem('leftNav')!);
            let filteredTemplate = HelperService.filterTree(
              'N',
              leftNav.filter((x: any) => x.id === FeatureKey.MY_PAGE),
              'IsFeature'
            );
            let allAdditionalFeatures: any;
            let rightsCheck: boolean;
            if (filteredTemplate.length > 0) {
              allAdditionalFeatures = filteredTemplate[0].children;
              if (+BaseServices.roleId === 5) {
                let userRightsId = Rights.EDIT_DEPARTMENT_EMPLOYEE_RIGHTS;
                let userRights = BaseServices.getUserRights();
                let data = JSON.parse(userRights);
                rightsCheck = HelperService.checkRightsData(data, userRightsId);
                this.enabledAdditionalFeatures = null;
                this.subscriptions.push(
                  this.employeeServices
                    .getById(this.employeeId)
                    .subscribe((result: any) => {
                      if (result) {
                        this.employeeDepartmentId = result.BusinessDepartmentId;
                        if (
                          this.loginEmployeeDepartmentId > 0 &&
                          this.employeeDepartmentId > 0 &&
                          this.loginEmployeeDepartmentId ===
                            this.employeeDepartmentId &&
                          rightsCheck === true
                        ) {
                          this.enabledAdditionalFeatures =
                            allAdditionalFeatures.filter(
                              (element: any) =>
                                element.checked || element.IsDefault
                            );
                        } else {
                          let userbasefeatures = allAdditionalFeatures.filter(
                            (element: any) =>
                              element.checked || element.IsDefault
                          );
                          this.enabledAdditionalFeatures =
                            userbasefeatures.filter(
                              (x: any) => x.id === 129 || x.id === 125
                            );
                          if (this.employeeId === +BaseServices.FeatureKey) {
                            this.enabledAdditionalFeatures =
                              allAdditionalFeatures.filter(
                                (element: any) =>
                                  element.checked || element.IsDefault
                              );
                          }
                        }
                      }
                    })
                );
              } else {
                this.enabledAdditionalFeatures = allAdditionalFeatures.filter(
                  (element: any) => element.checked || element.IsDefault
                );
              }
            }
          }

          this.subscriptions.push(
            this.route.firstChild.params.subscribe((params: Params) => {
              this.eId = +params['eid'];
            })
          );
          // document training
          if (this.enabledAdditionalFeatures != null) {
            this.enabledAdditionalFeatures.forEach((x: any) => {
              x.linkText = employeeTabLinkText(x, this.employeeId);
            });
          }

          const workingModule = sessionStorage.getItem('workingModule');
          if (workingModule && JSON.parse(workingModule).name === 'Employees') {
            this.employeeTitle = 'EMPLOYEES';
            this.employeeName = '';
          }
          if (this.eId > 0) {
            this.employeeTitle = 'EMPLOYEE';
            this.subscriptions.push(
              this.employeeServices.getById(this.eId).subscribe(result => {
                if (result) {
                  this.employeeName = ' - ' + result.Name;
                }
              })
            );
          }
          //endregion
        }
      )
    );
  }
  //#endregion

  //#region page-events
  /**
   * page init event
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.navigationRights();
    if (this.eId > 0) {
      this.employeeTitle = 'EMPLOYEE';
      this.subscriptions.push(
        this.employeeServices.getById(this.eId).subscribe(result => {
          if (result) {
            this.employeeName = ' - ' + result.Name;
          }
        })
      );
    }
  }

  //#endregion

  //#region methods
  /**
   * set employee title
   * @param employeeId {number}
   */
  setEmployeeTitle(employeeId?: number) {
    if (employeeId && employeeId > 0) {
      this.subscriptions.push(
        this.employeeServices.getById(employeeId).subscribe(res => {
          this.name = res.Name;
        })
      );
    } else {
      this.name = '';
    }
  }

  /**
   * Adds the work environment survey tab to the module tab row.
   *
   * TEMPORARY (#6073). Every other tab here comes from the feature tree the
   * backend sends at login — `Application.FeaturesTemplate` in the database,
   * read back out of `sessionStorage.workingModule` — so a tab cannot show up
   * until the feature is registered there. Until that SQL script is written the
   * entry is appended client-side, limited to the businesses listed in
   * `work-environment-survey-access.ts` so it does not surface everywhere.
   *
   * Delete this method and its call site once id 218 is in the feature string.
   * The tab is then filtered by `checked`/`IsDefault` like every other one,
   * and the object below is the exact shape the script has to insert.
   */
  private appendWorkEnvironmentSurveyTab(): void {
    if (!this.enabledAdditionalFeatures || !canUseWorkEnvironmentSurvey()) {
      return;
    }

    const alreadyPresent = this.enabledAdditionalFeatures.some(
      (feature: any) =>
        feature.id === FeatureKey.EMPLOYEE_WORK_ENVIRONMENT_SURVEY
    );

    if (alreadyPresent) {
      return;
    }

    this.enabledAdditionalFeatures.push({
      id: FeatureKey.EMPLOYEE_WORK_ENVIRONMENT_SURVEY,
      name: 'WorkEnvironmentSurvey',
      checked: true,
      linkText: 'work-environment-survey',
      access: true,
      navigationRoles: 'PB',
      // Dotted key: the module namespaces its strings under one object, the way
      // FLEXI_COMPLIANCE does, so the tab label is a child rather than a
      // top-level token. ecpl-tab-navigation pipes this straight through
      // `| translate`, which resolves a path.
      translationKey: 'WORK_ENVIRONMENT_SURVEY.TAB',
      key: '',
      IsFeature: 'FN',
      IsDefault: 0
    });
  }

  /**
   * disable tabs based upon the rights
   */
  navigationRights() {
    let role = BaseServices.UserRole;
    this.rightsData = employeeTabRights(role, rightId =>
      BaseServices.checkUserRights(rightId, role)
    );
    if (role === 'Portal') {
      this.title = 'OUR_EMPLOYEES';
    } else if (role === 'Guest' || role === 'Admin' || role === 'Editor') {
      this.title = 'EMPLOYEES';
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
